import { render, staticRenderFns } from "./ResearchDefinitionForm.vue?vue&type=template&id=870e503a&scoped=true"
import script from "./ResearchDefinitionForm.vue?vue&type=script&lang=js"
export * from "./ResearchDefinitionForm.vue?vue&type=script&lang=js"
import style0 from "./ResearchDefinitionForm.vue?vue&type=style&index=0&id=870e503a&prod&lang=scss&scoped=true"
import style1 from "./ResearchDefinitionForm.vue?vue&type=style&index=1&id=870e503a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "870e503a",
  null
  
)

export default component.exports